import React from 'react'
export const Favourites = () => {
  return (
    <div>Favourites</div>
  )
}
